
























































































































































































































import { Vue, Prop, Component } from "vue-property-decorator";
import { es } from "vuejs-datepicker/dist/locale";
import moment from "moment";

@Component({})
export default class WorkExperience extends Vue {
  @Prop(Object) user!: any;
  @Prop(Boolean) validate!: boolean;
  @Prop(Boolean) withCancelButton!: boolean;
  @Prop(Boolean) withTag!: boolean;
  @Prop(Function) saveWork!: any;
  @Prop(Function) cancelFunction!: any;
  optionsArea = [];
  es = es;
  hash = Math.random() * 100000;
  disabledDates = {
    from: new Date()
  };

  customFormatter(date: any) {
    return moment(date).format("DD-MM-YYYY");
  }

  async mounted() {
    let index;
    const response = await (this as any).$root._get("area", {});
    (this as any).optionsArea = response.data.map((item: any) => {
      return { ...item, label: item.description };
    });
    if ((this as any).user.nucleusTypeId) {
      let num_id =
        typeof this.user.nucleusTypeId === "object"
          ? this.user.nucleusTypeId.id
          : parseInt(this.user.nucleusTypeId);
      this.user.nucleusTypeId = this.optionsArea.find((i: any) => {
        return i.id === num_id;
      });
    }
  }
}
